import React, { Component } from 'react';
import axios from 'axios'
import './Dynamic.css'
import Header from '../../Components/header/Header'
import Banner from '../../Components/banner/Banner'
import Contact from '../../Components/footer-contact/Contact'
import {Link} from 'react-router-dom'
import { post, get,urlHOST  } from '../../Utils/request'

class Dynamic extends Component {
    constructor(params){
        super(params)
        
        this.state = {
            dynamiclist: [],
            total: 0,
            currentpage: '', 
        }
        this.addpage = this.addpage.bind(this)
        this.reducepage = this.reducepage.bind(this)
        this.getdata = this.getdata.bind(this)
        this.changepage = this.changepage.bind(this)
    }
    
    // 请求数据
    getdata(id){
        this.setState({
            currentpage:id
        })
        post('/manager/newsList',{
            "page":id
        }).then(res => {
            this.setState({
                dynamiclist:res.List,
                total:res.Total
            })
            
        })
    }
    componentDidMount(){
        this.getdata(this.props.match.params.page*1);
        this.setState({
            currentpage:this.props.match.params.page*1
        })
    }
    componentWillReceiveProps(nextProps){
        if(this.props.match.params.page*1!=nextProps.match.params.page*1){
            this.getdata(nextProps.match.params.page*1)
            this.setState({
                // currentpage:this.props.match.params.page*1
            })
        }
    }

    // 页码
    addpage() {
        this.setState({
            currentpage: this.state.currentpage*1 != this.state.total*1 ? this.state.currentpage*1 + 1 :1
        },()=>{
            this.getdata(this.state.currentpage*1);
            this.props.history.push(`/dynamic/${this.state.currentpage*1}`)
        })
    }
    reducepage() {
        this.setState({
            currentpage: this.state.currentpage*1 == 1 ? this.state.total : this.state.currentpage*1 - 1
        },()=>{
            this.getdata(this.state.currentpage*1);
            this.props.history.push(`/dynamic/${this.state.currentpage*1}`)
        })
    }
    changepage(page){
        this.setState({
            currentpage:page
        },()=>{
            this.getdata(this.state.currentpage);
            this.props.history.push(`/dynamic/${this.state.currentpage}`)
        })
    }
    
    render() {
        let totallist=[];
        for (var i=1;i<=this.state.total;i++){
            totallist.push(i)
        }
        return (
            <div className="dynamic1">
                {/* 公共头部组件 */}
                <Header push={this.props.history.push} propsEnroll={this.props}/>
                <Banner/>
            
                {/* 主体部分 */}
                <div className="wrapper">

                    {/* 头部文字栏 */}
                    <div className="wrapper-header">
                        <img alt="" src='/img/dynamic.png' />
                    </div>
                    
                    {/* 图文展示区 */}
                        <ul className="main-content-wrapper">

                            {
                                // let details=decodeURI(this.state.dynamiclist.details);
                                this.state.dynamiclist.map((obj,index) => (
                                    <li key={index} >
                                        <Link key={index} to={`/dynamic/${this.props.match.params.page}/news/${obj.news_id}`} className="main-content-wrapper-li">
                                            <div className="main-content-wrapper-each">
                                                {/* 图片 */}
                                                <img alt="" src={urlHOST+obj.picture} className="main-left-pic" />
                                                {/* 右侧 */}
                                                <div className="dynamic-main-right">
                                                    <div className="main-right-word">
                                                        <p className="main-right-word-title">
                                                            <div>{obj.tittle}</div>
                                                        </p>
                                                        <p className="main-right-word-content" dangerouslySetInnerHTML={{__html: decodeURI(obj.details).replace(/<[^>]+>/g, "")}}></p>
                                                    </div>
                                                    <div className="main-right-time">
                                                        <img alt="" src='/img/dynamicline.png' />
                                                        <p>{obj.created_at.split(' ')[0].substring(5,10)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                  ))
                            }
                            
                        </ul>

                        {/* 底部页码 */}
                        <div className=" page-container ">
                            <ul className=" page-middle ">
                                <li>
                                    <img onClick={this.reducepage} alt="" id="left" src="/img/left-arrow.png" />
                                </li> 
                                {
                                    totallist.map((item,index) => (
                                        this.props.match.params.page==item?
                                        <li key={index} onClick={this.changepage.bind(this,item)} className="page-num-choose">{item}</li>
                                        :<li key={index} onClick={this.changepage.bind(this,item)} className="page-num">{item}</li>
                                    ))
                                }                             
                                <li>
                                    <img onClick={this.addpage} id="right" alt="" src="/img/right-arrow.png" />
                                </li>
                            </ul>
                        </div>
                </div>   

                {/* 底部背景图 */}
                <Contact/>
            </div>
        );
    }
}

export default Dynamic;